import '../styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@edx/paragon';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';

import { getBusinessSeatUrl, isArchived } from '@utils/course';
import { intlShape } from '@prospectus/common/types/intlShape';
import courseRunShape from '@prospectus/common/types/courseRunShape';

import PurchaseBtn from '../components/PurchaseBtn';
import RequestBtn from '../components/RequestBtn';

const messages = defineMessages({
  'prospectus.course.mobile.business_message': {
    id: 'prospectus.course.business_message',
    description: 'Message soliciting business interest in this course',
    defaultMessage: 'Train your employees in the most in-demand topics, with edX For Business.',
  },
});

function BusinessBlockMobile({ intl, activeCourseRun }) {
  return (
    <Container size="sm" className="mt-3">
      <div className="d-flex justify-content-center flex-column text-primary-500">
        {intl.formatMessage(messages['prospectus.course.mobile.business_message'])}
        <PurchaseBtn
          businessSeatUrl={getBusinessSeatUrl(activeCourseRun)}
          isArchived={isArchived(activeCourseRun)}
          className="btn btn-primary mt-3"
        />
        <RequestBtn
          className="btn btn-outline-primary mt-2"
        />
      </div>
    </Container>
  );
}

BusinessBlockMobile.propTypes = {
  intl: intlShape.isRequired,
  activeCourseRun: PropTypes.shape(courseRunShape).isRequired,
};

export default injectIntl(BusinessBlockMobile);
